import React from 'react';
import {
    Button,
    SpaceBetween,
    BreadcrumbGroup,
    TextContent,
    Header,
    Container,
    Flashbar,
    Box,
} from '@amzn/awsui-components-console';
import { useParams, useHistory } from 'react-router-dom';
import { offboardLab } from '../apis';
import { displayErrorContent } from '../../../lib/utils';
import { SERVER_ERROR } from '../../../lib/constants';

export default function OffboardLab(props) {
    /**
     * Offboard lab component
     */
    const { id } = useParams();
    const history = useHistory();
    const { state } = props.location;
    const [loading, setLoading] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState([]);
    /**
     * set initial status
     */
    const setInitialStatus = () => {
        setLoading(true);
        setErrorMessage([]);
    };

    /**
     * click confirm button to trigger event
     */
    const onClick = async () => {
        let success = false;
        setInitialStatus();
        try {
            await offboardLab(id);
            success = true;
        } catch (err) {
            const errResponse = err.response;
            if (errResponse && errResponse.data && errResponse.status === 400) {
                const errorException = errResponse.data.errorException || 'Client Error';
                const errorMessage = errResponse.data.errorMessage || errResponse.data;
                displayErrorContent(errorException, errorMessage, setErrorMessage);
            } else {
                displayErrorContent(
                    SERVER_ERROR,
                    'Fail to offboard this lab, try again later or contact our dev team @ds2-device-farm-dev for more details.',
                    setErrorMessage
                );
            }
        }
        setLoading(false);
        if (success) {
            history.push('/lab-management/labs');
        }
    };

    return (
        <SpaceBetween size="s">
            <BreadcrumbGroup
                items={[
                    { text: 'DS2 Device Farm', href: '#' },
                    { text: 'Lab management', href: '#/lab-management/labs' },
                    { text: 'Offboard', href: '#/lab-management/labs/offboard' },
                ]}
                ariaLabel="Breadcrumbs"
            />
            <Header variant="h2" description="Offboard your lab from DS2 Device Farm if you don't need it any more">
                Offboard lab - {id}
            </Header>

            <Container header={<Header variant="h2">Offboard lab prerequisites</Header>}>
                <TextContent>
                    <ul>
                        <li>
                            Follow
                            <a href="https://w.amazon.com/bin/view/DS2DeviceFarm/Technical_Details/LabManagement/#HOffboardLab">
                                {' '}
                                detailed steps{' '}
                            </a>
                            to offboard devices in your lab
                        </li>
                        <li>
                            Follow
                            <a href="https://w.amazon.com/bin/view/DS2DeviceFarm/Technical_Details/LabManagement/#HOffboardLab">
                                {' '}
                                detailed steps{' '}
                            </a>
                            to offboard hosts in your lab
                        </li>
                        <li>
                            Click on confirm button to offboard the lab. Offboard process will fail if attached devices
                            and hosts are not offboarded.
                        </li>
                    </ul>
                </TextContent>
            </Container>
            <Box float="right">
                <SpaceBetween direction="horizontal" size="xs">
                    <Button href="#/lab-management/labs">Back</Button>
                    <Button loading={loading} onClick={onClick} variant="primary">
                        Confirm
                    </Button>
                </SpaceBetween>
            </Box>
            <Flashbar items={errorMessage} />
        </SpaceBetween>
    );
}
